<div class="conf-bar-section text-center">
    <ul class="conf-progressbar" #widgetsContent>
        <li *ngFor="let x of stepBarState.stepArr; let i = index">
            <a class="conf-progress" href="javascript:void(0)"
                [ngClass]="{'back': stepBarState.isGoingBack === true,'completed': x.value !== '', 'active' : x.active === true }">
                <div class="conf-p" (click)="goToStep(i)">
                    <p>{{i+1}}</p>
                </div>
                <div class="conf-progress-title-placeholder">
                    <div class="conf-progress-title-container">
                        <span class="conf-progress-title-text">{{x.title}}</span>
                    </div>
                    <div class="conf-progress-title-value-container">
                        <span class="conf-progress-title-value-text">{{x.value}}</span>
                    </div>
                </div>
                <label *ngIf="x.active === true"><img
                        [src]="progressStepBarImage"></label>
            </a>
        </li>
        <li><a class="conf-progress-last" href="javascript:void(0)"></a></li>
    </ul>

    <div class="accordion-item conf-accordion-item">
        <!-- <div class="panel">
            <p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.</p>
        </div> -->
        <div class="conf-step-count-resp"><app-conf-step-count></app-conf-step-count></div>

        <button (click)="change()" class="accordion-button collapsed conf-accordion-button" data-bs-toggle="collapse" data-bs-target="#flush-collapseOne" aria-expanded="false" aria-controls="flush-collapseOne" type="button">
            <p class="currentPage">{{currentStepTitle}}</p>
            <img [src]="imgurl === true ?   'assets/configurator/icons/conf-up.svg' : 'assets/configurator/icons/conf-down.svg'">
        </button>
<!-- dk -->
        <div id="flush-collapseOne" class="accordion-collapse collapse" aria-labelledby="flush-headingOne"
                data-bs-parent="#accordionFlushExample">
                <div class="accordion-body conf-accordion-body">
                    <ul class="conf-progressbar-resp">
                        <li *ngFor="let x of stepBarState.stepArr; let i = index" [ngClass]="len == i ? 'linehide' : ''">
                            <a class="conf-progress-resp" href="javascript:void(0)"
                                [ngClass]="{'back': stepBarState.isGoingBack === true,'completed': x.value !== '', 'active' : x.active === true }">
                                <div class="conf-p" (click)="goToStep(i)">
                                    <p>{{i+1}}</p>
                                </div>
                                <div class="conf-progress-title-placeholder">
                                    <div class="conf-progress-title-container">
                                        <span class="conf-progress-title-text">{{x.title}}</span>
                                    </div>
                                    <div class="conf-progress-title-value-container">
                                        <span class="conf-progress-title-value-text">{{x.value}}</span>
                                    </div>
                                </div>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>

<div class="modal conf-modal" tabindex="-1" role="dialog" data-backdrop="static" *ngIf="modalStatus">
    <div class="modal-dialog conf-modal-dialog" role="document">
        <div class="modal-content conf-modal-content">
            <div class="conf-modal-content-img-div">
                <img class="conf-modal-content-img" src="{{confAWSUrlStr}}/common/warning_icon.svg">
            </div>
            <div class="modal-header conf-modal-header">
                <h5 class="modal-title conf-modal-title">Edit Configuration</h5>
            </div>
            <div class="modal-body conf-modal-body">
                <p>Are you sure you want change the configuration? All subsequent customizations you have made will be
                    lost if you take this action !</p>
            </div>
            <div class="modal-footer conf-modal-footer">
                <button type="button" class="btn btn-secondary conf-btn-cancel" (click)="no_change()">Cancel</button>
                <button type="button" class="btn btn-primary conf-btn-yes" (click)="save_change()">Yes, Sure</button>
            </div>
        </div>
    </div>
</div>
